export const platform = [
  {
    value: 'ios',
    label: 'iOS',
  },
  {
    value: 'android',
    label: 'Android',
  },
  {
    value: 'android_ios',
    label: 'iOS & Android',
  },
]
